<template>
    <CModal :title="dialogTitle" :show.sync="dialogVisible">
        <CForm slot="default">
            <CInput
                v-model="model.title"
                :horizontal="true"
                label="Название"
                placeholder="Название категории"
            />
            <CInput
                v-model="model.code"
                :horizontal="true"
                label="Символьный код"
                placeholder="Например, fast-food"
            />
            <div class="flex items-center mt-2">
                <div class="w-3/12 col-form-label">Картинка</div>
                <div class="w-9/12 col-form-label">
                    <CInputFile
                        ref="picture"
                        horizontal
                        @change="selectPicture" />
                    <CImg
                        v-if="model.picture"
                        :src="pictureUrl(model.picture)"
                        class="m2"
                        width="200" />
                </div>
            </div>
        </CForm>

        <div slot="footer">
            <CButton
                color="light"
                class="ml-3"
                @click="close">Отмена</CButton>
            <CButton
                color="primary"
                class="ml-3"
                @click="submit">{{ submitButtonTitle }}</CButton>
        </div>
    </CModal>
</template>

<script>
    export default {
        name: 'RestaurantTypeUpsertDialog',

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data: () => ({
            dialogVisible: false,
            model: {
                title: '',
                code: '',
                picture: '',
            },
        }),

        computed: {
            dialogTitle() {
                const id = this.model && typeof this.model.id !== 'undefined' ? this.model.id : this.entity && this.entity.id;
                return typeof id === 'number'
                    ? 'Редактирование категории'
                    : 'Создание категории';
            },

            submitButtonTitle() {
                const id = this.model && typeof this.model.id !== 'undefined' ? this.model.id : this.entity && this.entity.id;
                return typeof id === 'number' ? 'Сохранить' : 'Создать';
            },
        },

        watch: {
            dialogVisible(v) {
                if (v) {
                    this.setModel(this.entity);
                }
            },
        },

        methods: {
            open() {
                this.dialogVisible = true;
            },

            close() {
                this.dialogVisible = false;
            },

            setModel(source) {
                this.model = {
                    title: source && source.title ? source.title : '',
                    code: source && source.code ? source.code : '',
                    picture: source && source.picture ? source.picture : '',
                    id: source && typeof source.id !== 'undefined' ? source.id : undefined
                };
            },

            pictureUrl(picture) {
                return picture ? `${process.env.VUE_APP_STATIC_BASE_URL}/${picture}` : '';
            },

            async selectPicture(FileList) {
                if (FileList && FileList[0]) {
                    const formData = new FormData();
                    formData.append('file', FileList[0]);
                    try {
                        const { data } = await this.axios.post('/files/upload', formData);
                        if (data?.filename) {
                            this.model.picture = data.filename;
                        }
                    } catch (err) {
                        this.$root.$emit('showError', 'Ошибка загрузки картинки. ' + err);
                    }
                }
            },

            async submit() {
                if (!this.model.title) {
                    this.$root.$emit('showError', 'Название категории не может быть пустым.');
                    return;
                }
                if (!this.model.code) {
                    this.$root.$emit('showError', 'Укажите символьный код категории.');
                    return;
                }

                try {
                    const { id, ...payload } = this.model;

                    if (typeof id === 'number') {
                        await this.axios.put(`/restaurant-types/${id}`, payload);
                    } else {
                        await this.axios.post('/restaurant-types', payload);
                    }

                    this.$emit('success');
                    this.close();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения категории. ' + err);
                }
            },
        },
    };
</script>
